import Vue from "vue"
import VueRouter from "vue-router"

import SiteCreate from './components/site/Create'
import SiteEdit from './components/site/Edit'
import SiteList from './components/site/List'

import EvaluationCreate from './components/evaluation/Create'
import EvaluationDetail from './components/evaluation/Detail'

import UserLoginView from './components/user/Login'
import UserRegisterView from './components/user/Register'
import UserPasswordResetView from './components/user/PasswordReset'
import UserPasswordResetTokenView from './components/user/PasswordResetToken'
import UserEmailVerifyTokenView from './components/user/EmailVerifyToken'
import UserDetailView from './components/user/Detail'
import UserDeleteView from './components/user/Delete'

import NotFoundView from "./components/navigation/NotFound"


Vue.use(VueRouter)

const intParser = (args) => (route) => {
  const response = {}
  for (const arg of args) {
    response[arg] = parseInt(route.params[arg], 10)
  }
  return response
}

const routes = [
  {path: '/', redirect: '/sites/'},
  {
    path: '/sites/',
    component: SiteList,
    name: 'site.list',
    pathToRegexpOptions: {strict: true},
    meta: {title: 'Sites'}
  },
  {
    path: '/sites/create/', 
    component: SiteCreate, 
    name: 'site.create', 
    pathToRegexpOptions: {strict: true}
  },
  {
    path: '/sites/:siteId(\\d+)/edit/',
    component: SiteEdit,
    name: 'site.edit',
    props: intParser(['siteId']),
    pathToRegexpOptions: {strict: true}
  },


  {
    path: '/sites/:siteId(\\d+)/evaluations/fill/',
    component: EvaluationCreate,
    name: 'evaluation.create',
    props: intParser(['siteId']),
    pathToRegexpOptions: {strict: true},
    meta: {title: 'Evaluate'}
  },
  {
    path: '/sites/:siteId(\\d+)/evaluations/start/',
    component: SiteEdit,
    name: 'evaluation.start',
    props: (route) => ({redirectToEvaluation: true, siteId: parseInt(route.params.siteId, 10)}),
    pathToRegexpOptions: {strict: true},
    meta: {title: 'Start Evaluation'}
  },
  {
    path: '/sites/:siteId(\\d+)/evaluations/:evaluationId(\\d+)/',
    component: EvaluationDetail,
    name: 'evaluation.detail',
    props: intParser(['siteId', 'evaluationId']),
    pathToRegexpOptions: {strict: true}
  },

  {
    path: '/user/login/', 
    component: UserLoginView, 
    name: 'user.login', 
    pathToRegexpOptions: {strict: true}
  },
  {
    path: '/user/sign-up/', 
    component: UserRegisterView, 
    name: 'user.register', 
    pathToRegexpOptions: {strict: true}
  },
  {
    path: '/user/password-reset/',
    component: UserPasswordResetView,
    name: 'user.password_reset',
    pathToRegexpOptions: {strict: true}
  },
  {
    path: '/user/password-reset/:uid/:token/',
    component: UserPasswordResetTokenView,
    name: 'user.password_reset_token',
    props: true,
    pathToRegexpOptions: {strict: true}
  },
  {
    path: '/user/verify/:uid/:token/',
    component: UserEmailVerifyTokenView,
    name: 'user.email_verify_token',
    props: true,
    pathToRegexpOptions: {strict: true}
  },
  {
    path: '/user/details/', 
    component: UserDetailView, 
    name: 'user.details', 
    pathToRegexpOptions: {strict: true}
  },
  {
    path: '/user/delete/', 
    component: UserDeleteView, 
    name: 'user.delete', 
    pathToRegexpOptions: {strict: true}
  },
  {
    path: '*', 
    component: NotFoundView, 
    name: 'notfound', 
    pathToRegexpOptions: {strict: true}
  }
]

let router = new VueRouter({
  routes,
  mode: 'history'
})

// This callback runs before every route change, including on page load.
router.beforeEach((to, from, next) => {
  let prefix = 'Heurix | '
  if (to.meta.title) {
    document.title = `${prefix}${to.meta.title}`
  } else {
    let titleFromName = to.name
      .replace('-', '.')
      .split('.')
      .map(bit => `${bit.charAt(0).toUpperCase()}${bit.slice(1)}`)
      .join(' ')
    document.title = `${prefix}${titleFromName}`
  }
  next()
})

export default router